export const Router: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48.8"
      height="34.415"
      viewBox="0 0 48.8 34.415"
      {...props}
    >
      <g transform="translate(-121.873 -152.659)">
        <path
          d="M197.893,153.76a10.909,10.909,0,0,1,7.769,3.213l.5-.5a11.7,11.7,0,0,0-16.528,0l.5.5A10.91,10.91,0,0,1,197.893,153.76Z"
          transform="translate(-51.62)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <path
          d="M212.8,172.907a7.572,7.572,0,0,0-10.7,0l.5.5a6.871,6.871,0,0,1,9.706,0Z"
          transform="translate(-61.182 -13.516)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <path
          d="M217.061,188.938a1.992,1.992,0,1,0,2.817,2.817,1.992,1.992,0,0,0,0-2.817A2.037,2.037,0,0,0,217.061,188.938Zm2.7,1.408a1.28,1.28,0,0,1-.378.913,1.321,1.321,0,0,1-1.826,0,1.292,1.292,0,0,1,.913-2.2,1.294,1.294,0,0,1,1.291,1.291Z"
          transform="translate(-72.197 -27.063)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <path
          d="M168.188,172.4h-5.045V154.555h-.7V172.4H130.105V154.555h-.7V172.4h-5.045a2.088,2.088,0,0,0-2.086,2.086v9.137a2.088,2.088,0,0,0,2.086,2.086h1.384v.751a1.366,1.366,0,0,0,1.364,1.364H132.4a1.366,1.366,0,0,0,1.364-1.364v-.751h25.017v.751a1.366,1.366,0,0,0,1.364,1.364h5.292a1.366,1.366,0,0,0,1.364-1.364v-.751h1.385a2.088,2.088,0,0,0,2.085-2.086v-9.137A2.088,2.088,0,0,0,168.188,172.4Zm-35.124,14.059a.664.664,0,0,1-.663.663h-5.292a.664.664,0,0,1-.663-.663v-.751h6.619Zm33.037,0a.664.664,0,0,1-.663.663h-5.292a.664.664,0,0,1-.664-.663v-.751H166.1Zm3.471-2.836A1.387,1.387,0,0,1,168.188,185H124.359a1.387,1.387,0,0,1-1.385-1.385v-9.137a1.387,1.387,0,0,1,1.385-1.385h43.828a1.386,1.386,0,0,1,1.384,1.385Z"
          transform="translate(0 -1.146)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <g transform="translate(136.524 177.554)">
          <rect
            width="2.786"
            height="0.701"
            transform="translate(16.715 0)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.8"
          />
          <rect
            width="2.786"
            height="0.701"
            transform="translate(11.143 0)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.8"
          />
          <rect
            width="2.786"
            height="0.701"
            transform="translate(5.572 0)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.8"
          />
          <rect
            width="2.786"
            height="0.701"
            transform="translate(0 0)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.8"
          />
        </g>
      </g>
    </svg>
  );
};
